// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/IdentityRoleSearchBy.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_Options_EnumValueOptions } from "../Options/EnumValueOptions_pb";

/**
 * Describes the file Enumerations/IdentityRoleSearchBy.proto.
 */
export const file_Enumerations_IdentityRoleSearchBy: GenFile = /*@__PURE__*/
  fileDesc("CidFbnVtZXJhdGlvbnMvSWRlbnRpdHlSb2xlU2VhcmNoQnkucHJvdG8SGnRpbWVfdHJhY2tpbmcuZW51bWVyYXRpb25zKkAKFElkZW50aXR5Um9sZVNlYXJjaEJ5EigKHElERU5USVRZX1JPTEVfU0VBUkNIX0JZX05BTUUQABoGysfNDwEDQiiqAiVNb2dpLlRpbWVUcmFja2luZy5Db21tb24uRW51bWVyYXRpb25zYgZwcm90bzM", [file_Options_EnumValueOptions]);

/**
 * Determines which columns of an Identity role can be used for text search.
 *
 * @generated from enum time_tracking.enumerations.IdentityRoleSearchBy
 */
export enum IdentityRoleSearchBy {
  /**
   * Search through the name of a role.
   *
   * @generated from enum value: IDENTITY_ROLE_SEARCH_BY_NAME = 0;
   */
  NAME = 0,
}

/**
 * Describes the enum time_tracking.enumerations.IdentityRoleSearchBy.
 */
export const IdentityRoleSearchBySchema: GenEnum<IdentityRoleSearchBy> = /*@__PURE__*/
  enumDesc(file_Enumerations_IdentityRoleSearchBy, 0);

